import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, FileText } from 'lucide-react';
interface MobilePreviewSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
export function MobilePreviewSheet({
  isOpen,
  onClose,
  children
}: MobilePreviewSheetProps) {
  return <AnimatePresence data-id="element-1022">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/40 z-40 md:hidden" data-id="element-1023" />

          {/* Sheet */}
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl z-50 md:hidden" style={{
        height: '85vh'
      }} data-id="element-1024">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-borderColor" data-id="element-1025">
              <div className="flex items-center gap-2" data-id="element-1026">
                <FileText className="w-5 h-5 text-violetBlue" data-id="element-1027" />
                <h3 className="font-semibold text-primary" data-id="element-1028">Preview</h3>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-1029">
                <X className="w-5 h-5 text-secondary" data-id="element-1030" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto h-[calc(100%-60px)]" data-id="element-1031">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}